export const environment = {
  firebase: {
    cloud_messaging_public_key:
      'BDX2xbfvWsx_g6cvrCFzS6CtQ2zoZGDOpZNcjda2msUyp4XUugi2uVS94tYM-xtCKR9U7S59F7WqsavO3xtV8bU',
  },
  intercom: {
    app_id: 'kq7usqo2',
  },
  logRocket: {
    app_id: 'vsim7q/ttc-prod',
  },
  production: true,
  recaptcha: { siteKey: '6LccWgkaAAAAAKqVt5xdiuFlTu2d5ulHwerH_nwJ' },
  workplace: {
    app_id: 1813135922313976,
  },
};
